import { ErpPermissionGroup, LogisticInvoicesActions } from 'collections/authorization';
import { AuthorizedRoute } from 'controllers/AuthorizedRoute';
import { LogisticInvoicePage } from 'pages';
import React from 'react';
import { Switch } from 'react-router-dom';
import { routes } from 'routes';

const LogisticInvoicesController = () => (
  <Switch>
    <AuthorizedRoute
      path={`${routes.logisticInvoicesPath()}/new`}
      group={ErpPermissionGroup.LogisticInvoices}
      action={LogisticInvoicesActions.Create}
    >
      <LogisticInvoicePage />
    </AuthorizedRoute>

    <AuthorizedRoute
      path={`${routes.logisticInvoicesPath()}/:invoiceId`}
      group={ErpPermissionGroup.LogisticInvoices}
      action={LogisticInvoicesActions.View}
    >
      <LogisticInvoicePage />
    </AuthorizedRoute>
  </Switch>
);

export default LogisticInvoicesController;
